import { RequestScope } from '@actions/api';
import { DateRangeType } from '@g17eco/types/common';

export enum SubmissionInsightsView {
  Sector = 'sector',
  Company = 'company',
}

export enum MetricView {
  Average = 'average',
  Total = 'total',
}

export interface SubmissionInsightsFilters {
  view: SubmissionInsightsView;
  metricView: MetricView;
  scopeGroup?: RequestScope;
}

export interface SubmissionInsightsFiltersWithDateRange extends SubmissionInsightsFilters {
  dateRange: DateRangeType;
  timeRange?: string | number;
}
